module.exports = __webpack_public_path__ + "static/media/Mapping.072a4a34.png";